/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { DOWNLOAD_CSV } from "../graphql/downloadReport.mutate";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";

const storageService = StorageModule.getInstance();

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetSchedulesReportMethods extends IPluginMethodMap {
  getSchedulesReport(args: any): Promise<any>;
}

export class GetSchedulesReportService implements IAgentPlugin {
  readonly methods: IGetSchedulesReportMethods;

  constructor() {
    this.methods = {
      getSchedulesReport: this.getSchedulesReport.bind(this),
    };
  }

  async getSchedulesReport(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let filter = {};

    if (args?.payload?.startDate && args?.payload?.endDate) {
      filter = {
        ...filter,
        band:
          storageService.get("currencyExchangeLocal", "local")?.bandId ?? null,
        eventStartTime__gte: args?.payload?.startDate,
        eventEndTime__lte: args?.payload?.endDate,
      };
    }

    try {
      if (client) {
        const res = await client.mutate({
          mutation: DOWNLOAD_CSV,
          variables: {
            filter: filter,
          },
          fetchPolicy: "no-cache",
        });
        return res;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
